import {
  REQUEST_LAWYER_ASSIGNED_CLAIMS,
  SET_LAWYER_ASSIGNED_CLAIMS,
  REQUEST_LEGAL_PROCEEDINGS_STEPS,
  SET_LEGAL_PROCEEDINGS_STEPS,
} from 'containers/LawyerAssignmentsPage/constants';
import { AssignedClaimResponse } from 'containers/CourtManagerAssignedClaims/typings';

export const requestLawyerAssignedClaims = (
  assignedLawyer: string,
  page: number,
  pageSize: number,
  step: string,
  procedureType: string,
  isDefaultAssignement: boolean,
) => ({
  type: REQUEST_LAWYER_ASSIGNED_CLAIMS,
  assignedLawyer,
  page,
  pageSize,
  step,
  procedureType,
  isDefaultAssignement,
});

export const setLawyerAssignedClaims = (assignment: AssignedClaimResponse) => ({
  type: SET_LAWYER_ASSIGNED_CLAIMS,
  assignment,
});

export const getLegalProceedingsSteps = (
  claimId: string,
  judiciaryProcessId: number,
) => ({
  type: REQUEST_LEGAL_PROCEEDINGS_STEPS,
  claimId,
  judiciaryProcessId,
});

export const setLegalProceedingsSteps = (steps: string[]) => ({
  type: SET_LEGAL_PROCEEDINGS_STEPS,
  steps,
});
